var map = {
	"./account-ico-mail.svg": 816,
	"./account-ico-pass.svg": 817,
	"./account-ico-phone.svg": 818,
	"./bank-transfer.svg": 819,
	"./betnearn-ico.svg": 820,
	"./birthday-bonus-ico.svg": 821,
	"./birthday.webp": 1903,
	"./bonus-code-ico.svg": 822,
	"./bonus-ico.svg": 823,
	"./bonus-received-ico.svg": 824,
	"./bonus.webp": 1904,
	"./business-account-upgrade-ico.svg": 825,
	"./check-in-daily-ico.svg": 826,
	"./checked.svg": 827,
	"./cloud-pointer.svg": 828,
	"./crypto.svg": 829,
	"./daily-bonus-ico.svg": 830,
	"./daily-limit.webp": 1905,
	"./deposit-delay-bonus-ico.svg": 831,
	"./e-wallet.svg": 832,
	"./earn-coin-ico.svg": 833,
	"./earn-x33-coin-ico.svg": 834,
	"./email.svg": 835,
	"./facebook.svg": 836,
	"./feedback.svg": 837,
	"./first-bet-ico.svg": 838,
	"./games-rebate-ico.svg": 839,
	"./info.svg": 840,
	"./instagram.svg": 841,
	"./instant-rebate.svg": 842,
	"./live-casino-rebate-ico.svg": 843,
	"./lucky-spin-ico.svg": 844,
	"./messenger.svg": 845,
	"./mobile-app-deposit-ico.svg": 846,
	"./monthly-cash.webp": 1906,
	"./msg-activity.svg": 847,
	"./msg-ann.svg": 848,
	"./msg-notice.svg": 849,
	"./new-icon.svg": 850,
	"./people-ico.svg": 851,
	"./quick-pay.svg": 852,
	"./r77-coin.svg": 853,
	"./rescue-bonus-ico.svg": 854,
	"./rescue-lc-ico.svg": 855,
	"./rescue-slots-ico.svg": 856,
	"./return.svg": 857,
	"./sc-bc-active-ico.svg": 858,
	"./sc-bc-ico.svg": 859,
	"./sc-bi-active-ico.svg": 860,
	"./sc-bi-ico.svg": 861,
	"./sc-mail-active-ico.svg": 862,
	"./sc-mail-ico.svg": 863,
	"./sc-mp-active-ico.svg": 864,
	"./sc-mp-ico.svg": 865,
	"./sc-pin-active-ico.svg": 866,
	"./sc-pin-ico.svg": 867,
	"./slots-rebate-ico.svg": 868,
	"./sports-rebate-ico.svg": 869,
	"./telegram.svg": 870,
	"./twitter.svg": 871,
	"./vip-up-level-ico.svg": 872,
	"./vip-weekly-bonus.svg": 873,
	"./wallet-ico.svg": 874,
	"./weekly-tournament-ico.svg": 875,
	"./welcome-bonus-ico.svg": 876,
	"./whatsapp.svg": 877,
	"./withdrawal-delay-bonus-ico.svg": 878,
	"./withdrawal.webp": 1907,
	"./x33-coin.svg": 879
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 481;